import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import Title from '../../../../components/typography/title.component'
import Detail from './components/points-transfer-detail'
import { Container } from './styles.style'

class PointsTransferPage extends React.Component {
	constructor(props) {
		super(props)
	}
	render() {
		return (
			<Container>
				<Title className="title">
					Seus pontos foram transferidos com sucesso!
				</Title>
				<Detail />
			</Container>
		)
	}
}

const mapStateToProps = () => ({})
const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch)
const connectedPointsTransferPage = withRouter(
	connect(mapStateToProps, mapDispatchToProps)(PointsTransferPage)
)

export { connectedPointsTransferPage as ModuleRootComponent }
